const styles = () => ({
  syncDetail: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  syncState: {
    color: '#7b8b99',
    fontSize: 14,
    fontWeight: 'normal',
    margin: 0,
  },

  loadingBar: {
    minWidth: 120,
    marginRight: 16,
  },

  circularLoader: {
    width: 18,
    height: 18,
    marginRight: 8,
  },

  bullet: {
    fontWeight: 900,
    margin: '0 7px',
  },
});

export default styles;
